import request from '@/router/axios';

//监控台-呼叫实时情况-接口
export const todayCallData = (params) => {
    return request({
      url: '/api/blade-stat/monitor/monitorCalled',
      method: 'get',
      params
    })
  }
//监控台-呼叫量趋势-接口
export const callVolumeTrendData = (params) => {
  return request({
    url: '/api/blade-stat/analysis/monthTrend',
    method: 'get',
    params
  })
}
//监控台-往年预青数据-接口
export const formerYearsYouthData = (params) => {
  return request({
    url: '/api/blade-stat/console/formerYearsYouthData',
    method: 'get',
    params
  })
}

//监控台-历年预青数据-接口
export const overYearsYouthData = (params) => {
  return request({
    url: '/api/blade-stat/console/overYearsYouthData',
    method: 'get',
    params
  })
}
//监控台-青少年信息-接口
export const adolescentData = (params) => {
  return request({
    url: '/api/blade-stat/monitor/youngAnalysis',
    method: 'get',
    params
  })
}
//监控台-救助数据-接口
export const salvageData = (params) => {
  return request({
    url: '/api/blade-stat/monitor/salvage',
    method: 'get',
    params
  })
}
//监控台-呼叫类型占比-接口
export const breatheTyleData = (params) => {
  return request({
    url: '/api/blade-stat/analysis/planWorkType',
    method: 'get',
    params
  })
}